module.exports = __webpack_public_path__ + "img/access-website_bg.2c068771.png";